import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listBooksApi, listSourcePreviewBooksApi, type BookSummary } from '../api';
import './Atlas.css';

export default function BooksPage() {
  const [books, setBooks] = useState<BookSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [sourceBookIds, setSourceBookIds] = useState<Set<string>>(new Set());

  useEffect(() => {
    let cancelled = false;
    listBooksApi(true)
      .then((items) => {
        if (!cancelled) setBooks(items);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    listSourcePreviewBooksApi()
      .then((ids) => { if (!cancelled) setSourceBookIds(new Set(ids)); })
      .catch(() => { /* PDF availability does not block book browsing. */ });
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="container atlas-page">
      <div className="atlas-hero">
        <div>
          <span className="atlas-kicker">权威资料 · 图文可查</span>
          <h1>图书资料</h1>
          <p>浏览已收录的水产图书，查看目录、关联品种和原书图片。</p>
        </div>
        <Link className="btn ghost" to="/search">← 返回 AI 搜索</Link>
      </div>

      <div className="atlas-count">
        <span>{loading ? '正在加载图书…' : `共 ${books.length} 册`}</span>
        {!loading && books.length > 0 && <span className="muted">资料持续整理更新</span>}
      </div>

      {failed ? (
        <div className="card atlas-empty">图书服务暂不可用，请稍后重试。</div>
      ) : loading ? (
        <div className="card atlas-empty">正在加载图书资料…</div>
      ) : books.length === 0 ? (
        <div className="card atlas-empty">暂时还没有可浏览的图书资料。</div>
      ) : (
        <div className="atlas-grid books-grid">
          {books.map((book) => (
            <Link key={book.id} className="atlas-card" to={`/book/${book.id}`}>
              <BookCardCover book={book} />
              <div className="atlas-card-body">
                <h2>{book.title}</h2>
                <span>{book.subtitle ?? book.publisher ?? '国家水产养殖种质资源名录'}</span>
                {sourceBookIds.has(book.id) && <span className="book-source-badge">可查看引用的 PDF 原文页</span>}
                <b>查看图书详情 →</b>
              </div>
            </Link>
          ))}
        </div>
      )}

      <div className="footer">©2026 上海渔联网科技 · 电子图鉴资料</div>
    </div>
  );
}

function BookCardCover({ book }: { book: BookSummary }) {
  const [failed, setFailed] = useState(false);
  return (
    <div className="atlas-cover book-card-cover">
      {book.cover_url && !failed
        ? <img src={book.cover_url} alt={`《${book.title}》封面`} loading="lazy" onError={() => setFailed(true)} />
        : <span aria-hidden="true">📘</span>}
    </div>
  );
}
